import type { EntryData } from '@/types/reward-machine';

export const REWARD_MACHINE_ERROR = {
    AUTH: 'auth',
    SERVER: 'server',
    TIME: 'time'
} as const;

export type RewardMachineError = (typeof REWARD_MACHINE_ERROR)[keyof typeof REWARD_MACHINE_ERROR] | null;

const HTTP_UNAUTHORIZED = 401;

export const mapEntryError = (entryData?: Pick<EntryData, 'error' | 'status'> | null): RewardMachineError => {
    if (!entryData?.error) {
        return null;
    }

    if (entryData.status === HTTP_UNAUTHORIZED) {
        return REWARD_MACHINE_ERROR.AUTH;
    }

    return REWARD_MACHINE_ERROR.SERVER;
};
